
import { computed, defineComponent, onMounted, reactive, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import { formatDate, formatThousands } from '@/utils'
import Container from '@/components/form/container/Container.vue'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import { getAvailableAcceptance, getCompanyByCompanyCode } from '@/apis/paymentSlip/paymentSlip'
import { formatBanendFlag, formatDraftType, formatSplitFlag } from '@/utils/acceptanceBillFormatUtil'

export default defineComponent({
  name: 'AvailableAcceptanceDialog',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  components: { SimpleTable, Container },
  emits: ['update:modelValue'],
  setup(props, context) {
    const { t } = useI18n()
    // 使用 computed 实现双向绑定
    const dialogVisible = computed({
      get: () => props.modelValue,
      set: (value) => context.emit('update:modelValue', value)
    })
    const paymentSlipTableStruct = [
      { prop: 'draftNo', label: t('pay.draftNo') },
      { prop: 'draftType', label: t('pay.draftType'), formatter: (row: any) => formatDraftType(row.draftType), width: 100 },
      { prop: 'splitFlag', label: t('pay.splitFlag'), formatter: (row: any) => formatSplitFlag(row.splitFlag), width: 100 },
      { prop: 'issueDate', label: t('pay.issueDate'), formatter: (row: any) => formatDate(row.issueDate, 'yyyy-MM-dd') },
      { prop: 'dueDate', label: t('Acceptance.dueDate'), formatter: (row: any) => formatDate(row.dueDate, 'yyyy-MM-dd') },
      { prop: 'bankName', label: t('pay.draftBankName') },
      { prop: 'banendFlag', label: t('pay.banendFlag'), formatter: (row: any) => formatBanendFlag(row.banendFlag) },
      { prop: 'draftAmt', label: t('pay.draftAmt'), formatter: (row: any) => formatThousands(row.draftAmt), align: 'right', width: 200 }
    ]
    const dataMap = reactive({
      viewData: Array<any>(),
      listLoading: true,
      activeName: 0,
      columnStruct: paymentSlipTableStruct,
      async getCompanyBankList() {
        dataMap.listLoading = true
        dataMap.viewData = []
        const res = await getAvailableAcceptance()
        if (res && res.data && res.data.length > 0) {
          for (const d of res.data) {
            if (dataMap.viewData.some(c => c.company === d.companyCode)) {
              continue
            }
            const company = await getCompanyByCompanyCode(d.companyCode)
            if (company && company.data && company.data.companyBanks && company.data.companyBanks.length > 0) {
              for (const b of company.data.companyBanks) {
                const acceptance = res.data.filter(r => r.companyBank === b.id)
                dataMap.viewData.push({ company: d.companyCode, bank: b.name, acceptance: acceptance })
              }
            }
          }
        } else {
          dataMap.viewData = []
        }

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      }
    })
    const handleCancel = () => {
      dialogVisible.value = false
    }
    onMounted(() => {
      dataMap.getCompanyBankList()
    })
    return {
      t,
      dialogVisible,
      handleCancel,
      ...toRefs(dataMap)
    }
  }
})
